import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainPrebidModuleSliceDTO } from './types'

export const DOMAIN_PREBID_MODULE_FRAGMENT: TypedDocumentNode<DomainPrebidModuleSliceDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainPrebidModuleFragment on DomainPrebidModule {
    domain {
      id
      activeAbTest {
        id
      }
      alerts {
        ...AlertFragment
      }
      name
    }
    enabled
    fieldAlerts {
      ...AlertFragment
    }
    id
    params
    paramsSchema {
      label
      name
      required
      tooltip
      type
    }
    updatedAt
  }
`
